import React from "react";

import {SuccessPanel, ErrorPanel, Heading, Subheading, Text, ReplayButton} from './style';
import routes from "package-common-react/lib/routes";

import GamesLinks from '../GamesLinks';

export function RegistrationHeading() {
  return null;
}

export function RegistrationSuccessPanel() {
  return (
    <SuccessPanel>
      <Heading>Merci d’avoir joué&nbsp;!</Heading>
      <Subheading>
        Un email vient de vous être envoyé. Nous vous souhaitons de très bonnes vacances et à bientôt dans votre centre PIÈCES&nbsp;AUTO.
      </Subheading>
      <GamesLinks size={75} />
    </SuccessPanel>
  );
}


export function RegistrationErrorPanel() {
  return (
    <ErrorPanel>
      <Heading>Attention !</Heading>
      <Text>
        Vous devez d'abord répondre au quiz avant de recevoir vos gains.
      </Text>
      <ReplayButton to={routes.play.path}>Rejouer</ReplayButton>
    </ErrorPanel>
  );
}




// WEBPACK FOOTER //
// ./src/components/RegistrationComponents/index.js